/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { createReducer, on } from '@ngrx/store';

import { MongoUser } from '@core/models/mongo';
import { UsersActions } from '../actions';
import { AccountActions } from '@settings/store/actions';
export const USERS_FEATURE_KEY = 'users';

export interface UsersState {
  users: MongoUser[];
  isLoading: boolean;
}

const initialState: UsersState = {
  users: null,
  isLoading: false,
} as any;

export const usersReducer = createReducer(
  initialState,
  on(UsersActions.loadUsers, UsersActions.createUser, UsersActions.updateUser, UsersActions.deleteUser, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(UsersActions.loadUsersSuccess, (state, { users }) => ({
    ...state,
    users,
    isLoading: false,
  })),
  on(UsersActions.createUserSuccess, (state, { user }) => ({
    ...state,
    users: [user, ...state.users],
    isLoading: false,
  })),
  on(UsersActions.updateUserSuccess, AccountActions.updateUserSuccess, (state, { user }) => ({
    ...state,
    users: state.users?.map((u) => (u._id === user._id ? user : u)),
    isLoading: false,
  })),
  on(UsersActions.deleteUserSuccess, (state, { _id }) => ({
    ...state,
    users: state.users.filter((user) => user._id !== _id),
    isLoading: false,
  })),
  on(
    UsersActions.loadUsersFailure,
    UsersActions.createUserFailure,
    UsersActions.updateUserFailure,
    UsersActions.deleteUserFailure,
    (state) => ({
      ...state,
      isLoading: false,
    })
  )
);
